<template lang="pug">
v-container(grid-list-xl, fluid, v-show="!estabelecimentoSelecionado", style="position: relative; height: 90vh;")
  v-layout(row, wrap).centralizado
    v-flex.md12.text-xs-center
      label.title.font-weight-bold Para acessar as informações é necessário selecionar uma loja.
      br
      v-btn(depressed, color="primary", large, @click="selectEstabelecimento()", style="color:white").br-5.mt-5 Selecionar

</template>

<script>
import _ from "lodash";

export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    }
  },
  methods: {
    selectEstabelecimento(){
      window.getApp.$emit("SELECT_ESTABELECIMENTO");
    },
  }
}
</script>

<style lang="scss" scoped>
.centralizado {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
